module.exports = __webpack_public_path__ + "img/lottery-dark.ce5c8986.png";